const state = {
  consultant: {
    id: '',
    name: ''
  }, // 业务顾问
  couponCode: '',
  showCheckDialog: false
}

const mutations = {
  'UPDATE_CONSULTANT'(state, consultant) {
    state.consultant = consultant
  },
  'UPDATE_COUPON_CODE'(state, couponCode) {
    state.couponCode = couponCode
  },
  UPDATE_SHOW_DIALOG (state, showCheckDialog) {
    state.showCheckDialog = showCheckDialog
  }
}

const actions = {
  UPDATE_CONSULTANT({ commit }, consultant) {
    commit('UPDATE_CONSULTANT', consultant)
  },
  UPDATE_COUPON_CODE ({ commit }, couponCode) {
    commit('UPDATE_COUPON_CODE', couponCode)
  },
  UPDATE_SHOW_DIALOG ({ commit }, showCheckDialog) {
    commit('UPDATE_SHOW_DIALOG', showCheckDialog)
  }
}
export default {
  state,
  actions,
  mutations
}
